export class ClaimPermission {
    public static  CREATE_CLAIM = "CREATE_CLAIM";
    public static UPDATE_CLAIM = "UPDATE_CLAIM";
    public static READ_CLAIM = "READ_CLAIM";
  }